import React from 'react'

import {
  View,
  StyleSheet,
  Dimensions,
} from 'react-native';

import ProjectList from '../project/ProjectList';
import PendingLabResults from '../project/PendingLabResults';
import StatsTicker from './StatsTicker';
import Colors from '../../constants/Colors';
import DashboardGraphs from './DashboardGraphs';

interface Props {
}

const ManagerDashboard: React.FC<Props> = ({ 
}) => {   
  return (<View style={styles.container}>
            <View style={styles.mainContainer}>
              <ProjectList />
            </View>
            <View style={styles.sideContainer}>
              <PendingLabResults />
              <StatsTicker />
              <DashboardGraphs />
            </View>
          </View>
  )
};

const width = Dimensions.get('window').width;

const styles = StyleSheet.create({ 
  stat: {
    fontSize: 26,
    fontWeight: 'bold',
  },

  statTitle: {
    fontSize: 20,
  },

  statsContainer: {
    width: width / 2 - 10,
    alignItems: 'center',
    marginHorizontal: 5,
    marginVertical: 20,
  },

  loadingText: {
    textAlign: 'center',
    padding: 10,
    fontWeight: 'bold'
  },

  button : {
    margin: 4,
  },

  modalView: {

  },

  modalText: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 20,
    margin: 20,
  },

  entryButton: {
    width: width - 20,
    marginLeft: 10,
    marginTop: 10,
  },

  inputLabel: {
    fontSize: 16,
    marginTop: 10,
    marginLeft: 15,
  },

  inputGroup: {
    flexDirection: 'row',
    marginLeft: 5,
  },

  input: {
    height: 50,
    width: width - 20,
    paddingVertical: 10,
    paddingHorizontal: 20,
    margin: 10,
    flex: 1,
    borderColor: Colors.borderGrey,
    borderWidth: 1,
    borderRadius: 20
  },

  container: {
    flexDirection: 'row'
  },

  mainContainer: {
    margin: "2%",
    width: "66%",
  },

  sideContainer: {
    marginTop: "2%",
    marginRight: "2%",
    width: "28%",
  },
});
export default ManagerDashboard